import React from "react";

let active_languages = {
  // Popular Languages
  "assembly": "Assembly",
  "bash": "Bash",
  "c": "C",
  "c++": "C++",
  "c#": "C#",
  "css": "CSS",
  "coffeescript": "CoffeeScript",
  "dart": "Dart",
  "elixir": "Elixir",
  "go": "Go",
  "groovy": "Groovy",
  "html": "HTML",
  "java": "Java",
  "javascript": "JavaScript",
  "julia": "Julia",
  "kotlin": "Kotlin",
  "lua": "Lua",
  "objective-c": "Objective C",
  "perl": "PERL",
  "php": "PHP",
  "powershell": "PowerShell",
  "python": "Python",
  "ruby": "Ruby",
  "rust": "Rust",
  "scala": "Scala",
  "shell": "Shell",
  "sql": "SQL",
  "swift": "Swift",
  "typescript": "TypeScript",

  // all languages
  "asp.net": "ASP.NET",
  "basic": "Basic",
  "batchfile": "Batchfile",
  "brainfuck": "Brainf#@$",
  "codequl": "CodeQL",
  "cython": "Cython",
  "d": "D",
  "dockerfile": "Dockerfile",
  "e": "E",
  "f#": "F#",
  "f*": "F*",
  "g-code": "G-code",
  "gdscript": "GDScript",
  "graphql": "GraphQL",
  "j": "J",
  "json": "JSON",
  "jsonwithcomments": "JSON with Comments",
  "json5": "JSON5",
  "lolcode": "LOLCODE",
  "markdown": "Markdown",
  "numpy": "NumPy",
  "r": "R",
  "sass": "Sass",
  "unrealscript": "UnrealScript",
  "vbscript": "VBScript",
  "vimscript": "Vim Script",
  "xml": "XML",
  // when adding langs, make sure either the key or value coorelates with the github lang id = https://github.com/search/advanced?q=a&type=Repositories (written in this language) (case insensitive). Also keep in alphabetical order.
};
export { active_languages };
